import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=41faabfd&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41faabfd')) {
      api.createRecord('41faabfd', component.options)
    } else {
      api.reload('41faabfd', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=41faabfd&", function () {
      api.rerender('41faabfd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/venueBooking/orderInformation/orderCharge/detail.vue"
export default component.exports